
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import { Table } from '@/interfaces/models/Table';
import headers from './headers';
import OrderList from '@/components/payment/OrderList.vue';
import { Page } from '@/interfaces/api/Page';
import { Payment } from '@/interfaces/models/Payment';
import { Order } from '@/interfaces/models/Order';
import { Venue } from '@/interfaces/models/Venue';
import { PaymentMethod } from '@/enums/PaymentMethod';
import { ValidationObserver } from 'vee-validate';
import { Permission } from '@/enums/Permission';
import { CustomerGroup } from '@/enums/CustomerGroup';
import { TableOptions } from '@/interfaces/components/TableOptions';

@Component({
  components: { OrderList, VTable },
})
export default class PaymentTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Table[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public orders!: Order[];
  @Prop({ type: Object, required: true }) public venue!: Venue;

  public $refs!: {
    table: InstanceType<typeof VTable> & { selected: any[] };
    observer: Array<InstanceType<typeof ValidationObserver>>;
  };

  public options: TableOptions = {};
  public expanded: string[] = [];

  get tableHeaders() {
    const headersMapped = headers.map((h: ColumnHeader) => ({ ...h, text: String(this.$t(h.text)) }));

    if (this.venue?.customerGroup !== CustomerGroup.TOPGOLF) {
      return headersMapped.filter(
        (h: ColumnHeader) => h.value !== 'merchantReference' && h.value !== 'checkoutId' && h.value !== 'actions',
      );
    }

    return headersMapped;
  }

  public isRefundable(item: Payment): boolean {
    if (item.method === PaymentMethod.CASH && this.$can(Permission.REFUNDS_CASH)) {
      return true;
    }

    return (
      [
        PaymentMethod.CREDIT_CARD,
        PaymentMethod.PAYPAL,
        PaymentMethod.APPLE_PAY,
        PaymentMethod.GOOGLE_PAY,
        PaymentMethod.WORLDLINE_RAW,
        PaymentMethod.WORLDLINE_MOBILE_APPLE_PAY,
        PaymentMethod.WORLDLINE_MOBILE_GOOGLE_PAY,
        PaymentMethod.WORLDLINE_MOBILE_CREDIT_CARD,
        PaymentMethod.VR_SEPA,
      ].indexOf(item.method) > -1
    );
  }

  public refund(data: { payment: Payment; order: string; articles: string[]; isExternal: boolean }) {
    this.$confirm(this.$t('payment.refundQuestion') as string).then((res: boolean) => {
      if (res) {
        this.$emit('refund', data);
      }
    });
  }

  public getOrders(item: Payment) {
    const orders: Order[] = this.orders.filter(
      // @ts-ignore
      (o: Order) => item.orders.map((o: Partial<Order>) => o._id).indexOf(o._id) > -1,
    );
    for (const order of orders) {
      for (const article of order.orderedArticles) {
        article.refundQuantity = article.quantity;
      }
    }

    return orders;
  }

  public onExpand(data: { item: Payment; value: boolean }) {
    if (data.value) {
      this.$emit('expand', data.item);
    }
  }
}
